import { render, staticRenderFns } from "./FBAType.vue?vue&type=template&id=234f1145&scoped=true"
import script from "./FBAType.vue?vue&type=script&lang=js"
export * from "./FBAType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f1145",
  null
  
)

export default component.exports